angular.module('unica_workshop.workshop_services')

.factory('WorkshopListService', function ($http, getBaseApiURL) {

	var workshopListService = {};

	workshopListService.list = function ( eventId, limit, offset ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.workshops;
			}

		});
	};

	workshopListService.fullList = function ( eventId ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop/full-list/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.workshops;
			}

		});
	};

	workshopListService.get = function ( workshopId ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop/detail/' + workshopId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop;
			}

		});

	};

	workshopListService.registered = function ( workshopId, limit, offset ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop/registered/' + workshopId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});

	};

	workshopListService.export = function (workshopId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/workshop/' + workshopId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};

	workshopListService.exportAll = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/all-workshop/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return workshopListService;
});